var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_20761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4343 3.28097L15.0931 6.93971L5.83172 16.2011L2.17502 12.5424L11.4343 3.28097ZM17.8694 2.39856L16.2377 0.766885C15.6072 0.136299 14.5832 0.136299 13.9505 0.766885L12.3875 2.32987L16.0463 5.98865L17.8694 4.16552C18.3585 3.6764 18.3585 2.88765 17.8694 2.39856ZM0.260304 17.685C0.193718 17.9847 0.464276 18.2532 0.763977 18.1803L4.84108 17.1918L1.18437 13.533L0.260304 17.685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_20761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9861,
    height: 17.9861,
    fill: "white",
    transform: "translate(0.250122 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8ea4400e8f017a0aad623ca88a8ede7.svg";
export { ForwardRef as ReactComponent };